import { TenantSettingsLayout } from "../../../../TenantProfile"
import { Outlet } from "react-router"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../../../Auth"

export default function Layout() {
	return (
		<ForbidUnlessAuthorized permission={PERMISSIONS.MANAGE_USERS}>
			<TenantSettingsLayout>
				<Outlet />
			</TenantSettingsLayout>
		</ForbidUnlessAuthorized>
	)
}
